'use client';
import { Suspense } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import WhatsAppButton from '../homepage/components/WhatsAppButton';
import QuoteFormSection from './components/QuoteFormSection';

function QuoteFormWrapper() {
  return <QuoteFormSection />;
}

const GetAQuotePage = () => {
  return (
    <>
      <Header />
      <main className="pt-20">
        <Suspense fallback={null}>
          <QuoteFormWrapper />
        </Suspense>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default GetAQuotePage;